import React from "react";
import { CellProps } from "../../../../../components/dataGrid/dataGrid";

import './defaultCell.scss';

const defaultCell: React.FC<CellProps> = ({ data: { displayValue } }) => {
    if (displayValue === null || displayValue === undefined) {
        return <span />;
    }

    return <div className="cell--default">
        {displayValue ?? 'N/A'}
    </div>
}

export default defaultCell;